import OptionNode from "../components/node-types/OptionNode";
//import BranchNode from "../components/BranchNode";
import EmailNode from "../components/node-types/EmailNode";
import ImageNode from "../components/node-types/ImageNode";
import PromptNode from "../components/node-types/PromptNode";
import AddNodePopup from "../components/designer/AddNodePopup";
import SelectListNode from "../components/node-types/SelectListNode";
import { NodeTypes } from "./node-types";
import TextInputNode from "../components/node-types/TextInputNode";
//import YesNoNode from "../components/YesNoNode";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ImageIcon from '@mui/icons-material/Image';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import TicketNode from "../components/node-types/TicketNode";
import FunctionNode from "../components/node-types/FunctionNode";

export const designerConfig = {
    nodeTypes: {
        optionNode: OptionNode,                
        imageNode: ImageNode,
        emailNode: EmailNode,
        promptNode: PromptNode,
        searchNodesNode: AddNodePopup,
        selectListNode: SelectListNode,
        textInputNode: TextInputNode,
        ticketNode: TicketNode,
        functionNode: FunctionNode
    }
}

export type AllowedConnection = {
    sourceHandleType: NodeTypes,
    destHandleType: NodeTypes,
    sourceNodeType: NodeTypes
}

export const rootNodeTypes = [
    {
        type: 'promptNode',
        label: 'Message Prompt',
        icon: <KeyboardIcon style={{ color: 'lightblue' }} />
    },
    {
        type: 'imageNode',
        label: 'Image',
        icon: <ImageIcon style={{ color: 'lightblue' }} />
    },
    {
        type: 'emailNode',
        label: 'Email',
        icon: <AlternateEmailIcon style={{ color: 'lightblue' }} />
    },
    {
        type: 'selectListNode',
        label: 'Select List',
        icon: <AlternateEmailIcon style={{ color: 'lightblue' }} />
    }
    ,
    {
        type: 'textInputNode',
        label: 'Text Input',
        icon: <AlternateEmailIcon style={{ color: 'lightblue' }} />
    }
    ,
    {
        type: 'ticketNode',
        label: 'Create Ticket',
        icon: <AlternateEmailIcon style={{ color: 'lightblue' }} />
    }
]